'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { initMixpanel, trackPageView } from '@/lib/mixpanel';

export default function MixpanelProvider() {
  const pathname = usePathname();

  // Initialize Mixpanel once on mount
  useEffect(() => {
    initMixpanel();
  }, []);

  // Track page view on every route change
  useEffect(() => {
    if (typeof window === 'undefined') return;
    trackPageView(pathname, document.title);
  }, [pathname]);

  return null;
}
